<template>
  <div class="footer">
    <div class="footer_content c">
      <div class="left">
        <div class="logo_box">
          <logoBox />
        </div>
        <div class="contact">
          <div class="item">
            <div class="item_title">联系我们</div>
            <div class="item_content">
              <p>
                <img class="icon-all" src="../assets/image/all/ic_phone.png" alt="" />
                <span>电话：188-3712-7271（钱经理）</span>
              </p>
              <p>
                <img class="icon-all" src="../assets/image/all/ic_mail.png" alt="" />
                <span>邮箱：ixueyanhui@163.com</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="item_title">平台技术交流群</div>
            <div class="item_content">
              <p>
                <img class="icon-all" src="../assets/image/all/ic_qq.png" alt="" />
                <span>文献求助QQ群：943494206</span>
              </p>
              <p>
                <img class="icon-all" src="../assets/image/all/ic_qq.png" alt="" />
                <span>测试交流QQ群：831767101</span>
              </p>
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          <div
            class="bottom_item"
            v-for="item in footerList"
            :key="item.name"
            @click="item.fn"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="right">
        <div class="official_account">
          <div class="img">
            <img :src="`${baseUrl}/static/defaults/gongzhonghao.png`" alt="" />
          </div>
          <div class="text">学研汇公众号</div>
        </div>
        <div class="video_account">
          <div class="img">
            <img :src="`${baseUrl}/static/defaults/shipinghao.png`" alt="" />
          </div>
          <div class="text">学研汇视频号</div>
        </div>
      </div>
    </div>

    <!-- <div class="put_record">
      @2021 学研汇All Rights Reserved 郑州米测信息科技有限公司
      豫ICP备20006655号-1
    </div> -->
    <complainDialog
      :visible="showComplainDialog"
      @closeDialog="closeDialog"
    ></complainDialog>
  </div>
</template>

<script>
import complainDialog from "@/components/dialogComponents/complainDialog.vue";
export default {
  components: { complainDialog },
  data() {
    return {
      showComplainDialog: false,

      footerList: [
        {
          name: "关于我们",
          fn: () => {
            this.$router.push("/aboutUs");
          },
        },
        // {
        //   name: "新手引导",
        //   fn: () => {
        //     this.$router.push("/guideView");
        //   },
        // },
        {
          name: "用户协议",
          fn: () => {
            this.$router.push("/serviceClause?id=10");
          },
        },
        {
          name: "隐私条款",
          fn: () => {
            this.$router.push("/serviceClause?id=2");
          },
        },
        {
          name: "投诉建议",
          fn: () => {
            this.showComplainDialog = true;
          },
        },
        {
          name: "资质证照",
          fn: () => {
            window.open(
              "https://static.xueyanhui.com/static/config/platform_license.pdf"
            );
          },
        },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.showComplainDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  min-width: 1200px;
  height: 400px;
  background-color: #444444;
  position: relative;
  color: #fff;
  box-sizing: border-box;
  .footer_content {
    padding: 50px 0 0px 0;
    display: flex;
    justify-content: space-between;

    .left {
      text-align: left;
      min-width: 439px;
      flex-shrink: 0;
      p {
        margin-bottom: 6px;
      }
      .logo_box {
        .text {
          width: 600px;
          font-size: 14px;
          margin-top: 5px;
        }
        img {
          max-width: 200px;
        }
        margin-bottom: 24px;
      }

      .contact {
        display: flex;
        padding-top: 12px;
        .item {
          // margin-bottom: 24px;
          // margin-right: 85px;
          .item_title {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 24px;
          }
          .item_content {
            color: rgba(255, 255, 255, 0.5);
            font-size: 16px;
            p {
              font-size: 16px;
              margin-right: 64px;
              display: flex;
              align-items: center;
              padding-bottom: 6px;
              span {
                font-size: 16px;
              }
              .bold {
                font-weight: 700;
                font-size: 20px;
                margin-right: 4px;
              }
              .iconfont {
                font-size: 26px;
                margin-right: 4px;
              }
            }
          }
        }
      }
      .title {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 10px;
        margin-left: 0;
      }
    }
    .right {
      display: flex;
      padding-top: 79px;
      .official_account,
      .applets,
      .video_account {
        margin-right: 80px;
        .img {
          width: 160px;
          height: 160px;
          background-color: #fff;
          border-radius: 16px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 16px;
          }
        }
        .text {
          font-size: 20px;
          margin-top: 16px;
        }
      }
      .video_account {
        margin-right: 0;
      }
    }
  }
  .footer_bottom {
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    padding-top: 60px;
    .bottom_item {
      font-size: 16px;
      margin-right: 40px;
      cursor: pointer;
      font-weight: 600;
    }
  }
  .put_record {
    // height: 72px;
    // line-height: 78px;
    margin-top: 24px;
    font-size: 14px;
  }
}

.hui_color {
  color: rgba(255, 255, 255, 0.5);
}
.icon-all{
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
</style>